import {Controller} from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['item', 'content', 'icon'];
    static classes = ['hidden', 'rotate'];

    toggle(event) {
        const clickedIndex = event.params.index;

        this.contentTargets.forEach((content, index) => {
            const isTarget = index === clickedIndex;
            const icon = this.iconTargets[index];

            if (isTarget) {
                const isOpening = content.classList.contains(this.hiddenClass);
                content.classList.toggle(this.hiddenClass);
                if (icon) icon.classList.toggle(this.rotateClass, isOpening);
            } else {
                content.classList.add(this.hiddenClass);
                if (icon) icon.classList.remove(this.rotateClass);
            }
        });
    }
}
